import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin: 100px 0px 40px 0px;
  margin-left: 115px;
  margin-right: 30px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 10px;
  justify-content: center;
  flex-basis: 60%;
`;

export const Title = styled.h3`
  font-size: 40px;
  font-family: Poppins-Regular;
  color: #1d1d1d;
  ${({ active }) =>
    active &&
    `
    border-bottom: 5px solid #F08700;

  `}
  cursor: pointer;
`;

export const Icon = styled.img`
  width: 29.03px;
  height: 32.25px;
`;

export const BottomContainer = styled.div``;

export const HorizontalLine = styled.hr`
  margin-left: -100px;
  border-right: 1px #00000029;
  margin-right: 118px;
  margin-left: 155px;
`;
